import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { createSimpleUser } from '../user/SimpleUser';

/**
 * # SnapshotList
 *
 * SnapshotList을 설명하세요.
 */
export const SnapshotList = types
  .model('SnapshotList')
  // --------------------------------------------------------------------------
  .props({
    regDt: types.number,
    updDt: types.maybeNull(types.number),
    snapHistSid: types.number,
    snapMonth: types.number,
    snapSeq: types.string,
    recvDt: types.number,
    transacId: types.string,
    sucesYn: types.boolean,
    orderSalesProjectCnt: types.number,
    govtProjectCnt: types.number,
    year: types.maybeNull(types.number),
    month: types.maybeNull(types.number),
    regUser: createSimpleUser(),
    updUser: types.maybeNull(createSimpleUser()),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model snapshotList --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as ISnapshotList;
      (Object.keys(newProps) as TSnapshotListKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TSnapshotList = Instance<typeof SnapshotList>;
type TSnapshotListSnapshot = SnapshotOut<typeof SnapshotList>;

export interface ISnapshotList extends TSnapshotList {}
export type TSnapshotListKeys = keyof TSnapshotListSnapshot & string;
export interface ISnapshotListSnapshot extends TSnapshotListSnapshot {}
export const createSnapshotList = () => types.optional(SnapshotList, {} as TSnapshotList);

export interface ISnapshotListFilter {
  year?: string;
  month?: string;
  page?: number;
  size?: number;
}
